"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _Comment = _interopRequireDefault(require("./model/Comment"));

var BASE_URI = 'composition/v1/comments';
var COMMENT_OBJECT_TYPE_COMPOSITION = 1;
var COMMENT_OBJECT_SUBTYPE_UNMAPPED = 0;

var uriForComment = function uriForComment(id) {
  return BASE_URI + "/" + id;
};

var CREATE_DATA = {
  objectType: COMMENT_OBJECT_TYPE_COMPOSITION,
  objectSubType: COMMENT_OBJECT_SUBTYPE_UNMAPPED
};

var CommentsManager = /*#__PURE__*/function () {
  function CommentsManager() {
    (0, _classCallCheck2.default)(this, CommentsManager);
  }

  (0, _createClass2.default)(CommentsManager, [{
    key: "createComment",
    value: function createComment(data) {
      var submitData = Object.assign({}, CREATE_DATA, {}, data);
      return _apiClient.default.post(BASE_URI, {
        data: submitData
      }).then(_Comment.default.fromJS);
    }
  }, {
    key: "deleteComment",
    value: function deleteComment(id) {
      return _apiClient.default.delete(uriForComment(id));
    }
  }]);
  return CommentsManager;
}();

exports.default = CommentsManager;
module.exports = exports.default;